import * as observationApi from '@/api/observations'
import {
  FETCH_OBSERVATIONS,
  FETCH_OBSERVATIONS_SUCCESS,
  FETCH_OBSERVATIONS_FAILURE,
  OBSERVATION_SELECTED,
  OBSERVATION_DESELECTED,
} from '../mutation-types'

const categorizeSelectedObservations = (state) => {
  const { selectedObservations } = state
  const color = state.colors.filter(color => selectedObservations.includes(color))
  const odor = state.odors.filter(odor => selectedObservations.includes(odor))
  const taste = state.tastes.filter(taste => selectedObservations.includes(taste))
  const obsState = state.states.filter(state => selectedObservations.includes(state))
  const symptom = Object.keys(state.symptoms).reduce(
    (acc, curr) => acc.concat(state.symptoms[curr]), [])
    .filter(symptom => selectedObservations.includes(symptom))
  return { color, odor, taste, state: obsState, symptom }
}

const actions = {
  fetchObservations: async ({ commit }) => {
    try {
      commit(FETCH_OBSERVATIONS)
      const response = await observationApi.fetchObservations()
      commit(FETCH_OBSERVATIONS_SUCCESS, response.data)
    } catch (error) {
      console.error(error)
      commit(FETCH_OBSERVATIONS_FAILURE, error)
    }
  },
  selectObservation: ({ commit, dispatch, state }, observation) => {
    commit(OBSERVATION_SELECTED, observation)
    if (state.selectedObservations.length > 0) {
      dispatch('fetchAgentsByObservations', categorizeSelectedObservations(state))
    }
  },
  deselectObservation: ({ commit, dispatch, state }, observation) => {
    commit(OBSERVATION_DESELECTED, observation)
    if (state.selectedObservations.length > 0) {
      dispatch('fetchAgentsByObservations', categorizeSelectedObservations(state))
    }
  }
}

export default actions
